import script from "./ComPageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComPageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ComPageHeader.vue?vue&type=style&index=0&id=1b022643&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b022643"]])

export default __exports__